import { render, staticRenderFns } from "./promotionList.vue?vue&type=template&id=57ac5455&"
import script from "@/scripts/promotion/promotionList.js?vue&type=script&lang=js&"
export * from "@/scripts/promotion/promotionList.js?vue&type=script&lang=js&"
import style0 from "./promotionList.vue?vue&type=style&index=0&id=57ac5455&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports